import { FC, Fragment } from 'react';

import { TriangleAlert } from 'lucide-react';
import { isEmpty, isNullish } from 'remeda';
import useSWR from 'swr';

import Alert from '@mui/material/Alert';

import { CreateMasterKeyButton } from './createMasterKeyButton/CreateMasterKeyButton';
import { MasterKeyCard } from './masterKeyCard/MasterKeyCard';

import css from './MasterKeyPage.module.css';

import { masterKeyService } from 'v2/api/masterKeyService';
import { EmptyPlaceholder } from 'v2/components/emptyPlaceholder/EmptyPlaceholder';
import { Loader } from 'v2/components/loader/Loader';
import { PageLayout } from 'v2/components/pageLayout/PageLayout';
import { PageTitle } from 'v2/components/pageLayout/pageTitle/PageTitle';

export const MasterKeyPage: FC = () => {
  const { data, isLoading, mutate } = useSWR('getMasterKeys', masterKeyService.getMasterKeys);

  return (
    <PageLayout className={css.masterKeyPage} overflow="hidden">
      <PageTitle action={<CreateMasterKeyButton onSuccess={mutate} />}>Master Key Settings</PageTitle>

      <Alert className={css.masterKeyPageAlert} severity="warning" icon={<TriangleAlert />}>
        Your master key provides full access to your account. Store it securely and never share it publicly.
      </Alert>

      {isLoading ? (
        <Loader />
      ) : (
        <div className={css.masterKeys}>
          {isNullish(data) || isEmpty(data) ? (
            <EmptyPlaceholder />
          ) : (
            <Fragment>
              {data.map((masterKey) => (
                <MasterKeyCard key={masterKey.id} masterKey={masterKey} onRevalidate={mutate} />
              ))}
            </Fragment>
          )}
        </div>
      )}
    </PageLayout>
  );
};
